export default __webpack_public_path__ + "language-component.dba7eff1.png";